import "./about.css";
import React from "react";
import TitleBox from "../../components/TitleBox/TitleBox";
import { aboutImages, aboutVideos } from "../../assets/images/aboutImg";
import { useTranslation } from "react-i18next";

function About() {
  const { t } = useTranslation();

  return (
    <div className="about-container route">
      <div className="about-header">
        <div className="header-back-img">
          <img src={aboutImages.aboutheader} alt="header-img" />
        </div>

        <div className="header-front-container">
          <div className="header-title">
            <TitleBox title={t("about")} />
          </div>

          <div className="header-front-img">
            <img src={aboutVideos.headerVideo1} alt="header-front-img" />
          </div>

          <section className="about-section">
            <div className="history-image">
              <img src={aboutImages.payeHistory} alt="history-img" />
            </div>

            <div className="text">
              <h4 className="title">PAYE PLAST TİCARET VE SANAYİ LTD. ŞTİ.</h4>

              <p>
                {t("homepage_who_are_we_text1")} <br />
                {t("homepage_who_are_we_text2")}{" "}
              </p>
              <br />
              <p>{t("homepage_who_are_we_text3")}</p>
              <br />
              <p>{t("homepage_who_are_we_text6")}</p>
              <br />
              <p>{t("homepage_who_are_we_text4")}</p>
              <br />
              <p>{t("homepage_who_are_we_text5")}</p>
            </div>

          </section>
        </div>
      </div>
    </div>
  );
}

export default About;
